/* global angular */

var ngModule = angular.module('trends');

ngModule.directive('exportToBasket', ['Api',
    function (Api) {
        return {
            restrict: 'A',
            scope: true,
            link: function (scope, element, attrs) {
                var item_id = attrs.exportToBasket;

                scope.getMode = function () {
                    return 'export';
                };

                scope.initialFormValues = function () {
                    return { };
                };

                scope.getData = function () {
                    return { };
                };

                scope.passState = function () {
                    return undefined;
                };

                scope.submitForm = function () {
                    return Api.export_basket.post({ ids: [ { item_id: parseInt(item_id) } ] });
                };

                // Submit on show
                scope.onModalShow = function (modalScope) {
                    modalScope.submit();
                };
            }
         };
    }]);
